import { useTranslation } from 'react-i18next';
import { Button, Icon, IconButton, RichTextArea, Stack, styled, Text } from 'shell/components';
import { CUSTOM_CONTENT_WORD_COUNT_LIMIT } from 'utils/constants';
import { getHTMLWordCount } from 'utils/helper';

const FeedbackExamples = ({ examples, onChange }) => {
    const { t } = useTranslation('quiz');
    const getExampleLabel = (number) => t('feedback.example', 'Feedback Example #{{number}}', { number });

    return (
        <Stack spacing={3}>
            <Stack spacing={2}>
                <Text variant={'p1'} weight={'semibold'}>
                    {t('feedback.teach-style', 'Teach the AI Your Style')}
                </Text>
                <Text color={'light'}>
                    {t(
                        'feedback.teach-style-description',
                        'Share some sample feedback you’ve written for students. This helps the AI suggest feedback that feels more natural and aligned with your voice.'
                    )}
                </Text>
            </Stack>
            {examples.map((example, index) => (
                <ExampleCard key={index} spacing={3}>
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                        <Text weight={'medium'}>{getExampleLabel(index + 1)}</Text>
                        <IconButton
                            kind={'delete'}
                            size={'small'}
                            variant={'square'}
                            disabled={examples.length === 1}
                            aria-label={t('feedback.remove-example', 'Remove feedback example {{number}}', {
                                number: index + 1,
                            })}
                            tooltip={{ component: t('common:controls.delete', 'Delete') }}
                            onClick={() => onChange(examples.filter((_, exampleIndex) => exampleIndex !== index))}
                        />
                    </Stack>
                    <RichTextArea
                        aria-label={getExampleLabel(index + 1)}
                        value={example}
                        placeholder={t('feedback.example-placeholder', 'Enter one feedback example here')}
                        error={getHTMLWordCount(example) > CUSTOM_CONTENT_WORD_COUNT_LIMIT}
                        helperText={t('assignment:remaining-word-count', '{{wordLimitStatus}} words', {
                            wordLimitStatus: `${getHTMLWordCount(example)}/${CUSTOM_CONTENT_WORD_COUNT_LIMIT}`,
                        })}
                        helperTextPosition={'end'}
                        onChange={(html) =>
                            onChange(examples.map((current, exampleIndex) => (exampleIndex === index ? html : current)))
                        }
                    />
                </ExampleCard>
            ))}
            <Button
                startIcon={<Icon kind={'add'} />}
                variant={'borderless'}
                sx={{ alignSelf: 'flex-start' }}
                onClick={() => onChange([...examples, ''])}
            >
                {t('feedback.add-example', 'Add another example')}
            </Button>
        </Stack>
    );
};

const ExampleCard = styled(Stack)(({ theme }) => ({
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.ensightful.neutral[300]}`,
    borderRadius: '16px',
    background: theme.palette.ensightful.neutral[50],
}));

export default FeedbackExamples;
